import { useMemo } from 'react'
import dayjs from 'date'
import { usePurchasedModules } from 'models/city'

import { useTestDiff } from 'layers/immortals/pages/HomePage/components/Counter/util/useCountdown'


const useImmortalsEnabled = () => {
  const testDiff = useTestDiff()
  const { purchasedModuleTags } = usePurchasedModules()

  const isImmortalsEnabled = useMemo(() => {
    if (purchasedModuleTags?.includes('IMMORTALS')) {
      const now = dayjs().add(testDiff, 'seconds')
      const year = now.format('YYYY')
      const end = dayjs(`10.05.${year}`, 'DD.MM.YYYY')
      const start = end.add(-22, 'days')

      return now >= start && now <= end
    }

    return false
  }, [ purchasedModuleTags, testDiff ])

  return {
    isImmortalsEnabled,
  }
}


export default useImmortalsEnabled
